var TYPES = {
    ONLINE: 0x1,
    OFFLINE: 0x2
};

var plugin = angular.module('dfx.check-connection', []);

var CheckConnectionProvider = function () {

    var useAjax = true,
        requestUrl = 'favicon.ico',
        requestInterval = 5000;

    this.setAjaxUsing = function (use) {
        useAjax = use;
    };

    this.setRequestUrl = function (url) {
        requestUrl = url;
    };

    this.setRequestInterval = function (interval) {
        requestInterval = interval;
    };

    this.$get = ['$http', '$log', function ($http, $log) {

        var intervalHandler,
            currentListenerId = -1,
            listeners = [];

        function subscribe(cb, t) {
            if (typeof (cb) !== 'function') {
                throw new Error('Callback should be a function');
            }
            listeners.push({
                t: t,
                id: ++currentListenerId,
                cb: cb
            });
            return currentListenerId;
        };

        function subscribeOnline(cb) {
            return subscribe(cb, TYPES.ONLINE);
        };

        function subscribeOffline(cb) {
            return subscribe(cb, TYPES.OFFLINE);
        };

        function unsubscribe(listenerId) {
            listeners = listeners.filter(function (el) {
                return el.id === listenerId;
            });
        };

        function onOnline() {
            listeners
                .filter(function (el) { return el.t == TYPES.ONLINE; })
                .forEach(function (el) { el.cb.call(null); });
        };

        function onOffline() {
            listeners
                .filter(function (el) { return el.t == TYPES.OFFLINE; })
                .forEach(function (el) { el.cb.call(null); });
        };

        function startChecker() {
            window.addEventListener('offline', onOffline);
            window.addEventListener('online', onOnline);
            if (useAjax) {
                startInterval();
            }
        };

        function stopChecker() {
            window.removeEventListener('offline', onOffline);
            window.removeEventListener('online', onOnline);
            if (useAjax) {
                stopInterval();
            }
        };

        function startInterval() {
            intervalHandler = setInterval(function () {
                $http({ url: requestUrl, method: 'HEAD' }).then(function () {
                    onOnline();
                }).catch(function (err) {
                    if (err.status === -1) {
                        onOffline();
                    }
                })
            }, requestInterval);
        };

        function stopInterval() {
            clearInterval(intervalHandler);
        };

        return {
            subscribeOnline: subscribeOnline,
            subscribeOffline: subscribeOffline,
            unsubscribe: unsubscribe,
            startChecker: startChecker,
            stopChecker: stopChecker
        };

    }];

};

plugin.provider('CheckConnection', CheckConnectionProvider);

module.exports = 'dfx.check-connection';